import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import useMediaQuery from "../../hooks/useMediaQuery";

const SpeakerCard = ({ speaker }) => {
    const [isFlipped, setIsFlipped] = useState(false);
    const isMobile = useMediaQuery("(max-width: 768px)");

    const toggleFlip = () => {
        setIsFlipped((prev) => !prev);
    };

    return (
        <motion.div
            className="w-full mt-3 md:mt-10 h-[360px] md:h-[325px] [perspective:1000px] cursor-pointer group"
            onHoverStart={() => !isMobile && setIsFlipped(true)}
            onHoverEnd={() => !isMobile && setIsFlipped(false)}
            onClick={isMobile ? toggleFlip : undefined}
        >
            <motion.div className="w-full h-[80%] md:h-[100%] rounded-2xl shadow-lg [transform-style:preserve-3d] transition-all duration-150" animate={{ rotateY: isFlipped ? 180 : 0 }}>
                <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl p-6 [backface-visibility:hidden]">
                    <img src={speaker?.image} alt={speaker?.name} className="w-40 h-40 rounded-full mx-auto mb-4 mt-[-80px] object-cover border-4 border-white shadow-lg" />
                    <h3 className="text-xl font-semibold text-center mb-2 text-indigo-800">{speaker?.name}</h3>
                    <p className="text-gray-600 text-center line-clamp-3">{speaker?.shortBio}</p>
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
                        <ChevronDown className="w-6 h-6 text-indigo-500 animate-bounce" />
                    </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-100 to-blue-100 rounded-2xl p-6 [backface-visibility:hidden] [transform:rotateY(180deg)]">
                    <h3 className="text-xl font-semibold text-center mb-4 text-indigo-800">{speaker?.name}</h3>
                    <p className="text-gray-700 text-sm overflow-y-auto h-[calc(100%-4rem)] scrollbar-thin scrollbar-thumb-indigo-200 scrollbar-track-transparent pr-2">{speaker?.fullBio}</p>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default SpeakerCard;
